import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-lesson-paginator.tsx
var LazyCourseLessonPaginator = lazy(() => import("./course-lesson-paginator-Qb8vbxR9.js").then((n) => n.n).then((module) => ({ default: module.CourseLessonPaginator })));
function CourseLessonPaginator(props) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-paginator" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonPaginator, { ...props })
	});
}
function CourseLessonPaginatorContent(props) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-paginator" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonPaginator, { ...props })
	});
}
var useCourseLessonPaginatorContent = () => {
	return useMemo(() => ({ courseLessonPaginator: { component: CourseLessonPaginatorContent } }), []);
};
//#endregion
export { CourseLessonPaginator, useCourseLessonPaginatorContent };
